import React from 'react';
import { IconContext } from 'react-icons';
import {
    SiCplusplus,
    SiPython,
    SiJavascript,
    SiHtml5,
    SiCss3,
    SiNodedotjs,
    SiTsnode,
    SiMongodb,
    SiExpress,
    SiPostgresql,
    SiFlask,
    SiDjango,
    SiScikitlearn,
    SiTensorflow,
    SiPytorch,
    SiTailwindcss,
    SiReact,
    SiNumpy,
    SiPandas,
    SiPlotly,
} from 'react-icons/si';
const Skills = () => {
    const skills = [
        {
            name: 'Web Development',
            list: [
                <SiPython />,
                <SiFlask />,
                <SiDjango />,
                <SiHtml5 />,
                <SiCss3 />,
                <SiJavascript />,
                <SiTsnode />,
                <SiNodedotjs />,
                <SiMongodb />,
                <SiExpress />,
                <SiPostgresql />,
                <SiTailwindcss />,
                <SiReact />,
            ],
            percent: 75,
        },
        {
            name: 'Machine Learning ',
            list: [
                <SiPython />,
                <SiNumpy />,
                <SiPandas />,
                <SiPlotly />,
                <SiScikitlearn />,
                <SiTensorflow />,
                <SiPytorch />,
            ],
            percent: 70,
        },
        {
            name: 'Competitive Programming ',
            list: [<SiCplusplus />, <SiPython />],
            percent: 70,
        },
    ];
    return (
        <div className='backdrop-blur bg-white/20 w-4/5 sm:max-w-7xl mx-auto my-4 px-2 py-4 h-auto'>
            <h1 className='text-center font-bold text-4xl'>My Skills</h1>
            <div className='flex flex-wrap items-center'>
                {skills.map((skill, idx) => {
                    return (
                        <div
                            key={idx}
                            className='w-100 md:w-2/4 mx-auto my-2 p-2 h-auto'
                        >
                            <div className='mx-2 sm:mx-8'>
                                <div className='flex justify-between mb-1'>
                                    <h1 className='text-center font-bold text-2xl mx-2 sm:mx-4'>
                                        {skill.name}
                                    </h1>
                                    <p className='grid text-sm content-end mx-2'>
                                        {skill.percent}%
                                    </p>
                                </div>
                                <div className='w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700'>
                                    <div
                                        className='bg-[#ffd700] h-2.5 rounded-full'
                                        style={{
                                            width: `${skill.percent}%`,
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className='flex flex-wrap  p-4'>
                                {skill.list.map((tech, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            className='flex place-content-center w-10 h-10 sm:w-20 sm:h-20 p-2 border-2 m-3 hover:scale-110  transition-all grow'
                                        >
                                            <IconContext.Provider
                                                value={{
                                                    color: 'silver',
                                                    className:
                                                        'my-auto w-6 h-6 sm:w-14 sm:h-14 ',
                                                }}
                                            >
                                                {tech}
                                            </IconContext.Provider>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Skills;
